import { render, staticRenderFns } from "./ApprovalBubble.vue?vue&type=template&id=7ac1305a"
import script from "./ApprovalBubble.vue?vue&type=script&lang=js"
export * from "./ApprovalBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports